module.exports = __webpack_public_path__ + "img/user-group-icon.aae114cd.svg";